import { createStyles } from '@material-ui/core';
import { UNIT, mainColor } from '../../constants/theme';

export const styles = createStyles({
  table: {
    minWidth: UNIT * 43.75
  },
  progress: {
    margin: UNIT * 5,
    textAlign: 'center',
    color: mainColor.secondaryColor
  },
  icon: {
    fontSize: UNIT * 1.5,
    color: 'black'
  },
  heading: {
    fontSize: UNIT * 0.9375,
    minWidth: UNIT * 12,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight
  },
  tableRow: {
    fontSize: UNIT * 0.9375,
    padding: UNIT * 1.0625
  },
  typo: {
    fontSize: UNIT * 0.875
  },
});
